import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false, loginPath = "/login" }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (!user) {
    // R101.19 — preserve intended destination as ?next so Login can return
    // the user here after successful auth. R110.126 — include hash too so
    // "?spotlight=X&brand=Y#franchise-match-section-X" deep-links scroll
    // to the right section after login. `loginPath` lets B2B flows send the
    // visitor to the existing /partner/login instead of the consumer login.
    const from = `${loc.pathname}${loc.search || ""}${loc.hash || ""}`;
    return <Navigate to={`${loginPath}?next=${encodeURIComponent(from)}`} replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
